import { CreateRetailSalesReportDto } from './../../../dtos/documents/RetailSalesReport/CreateRetailSalesReportDto';
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { RetailSalesReportDetail } from "../../../components/Pages/Documents/RetailSalesReport/RetailSalesReportDetail";
import RetailSalesReportList from "../../../components/Pages/Documents/RetailSalesReport/RetailSalesReportList";
import { NFLookupRetailSalesReport } from "../../../components/Shared/NewForms/NFLookupRetailSalesReport";
import { RetailSalesReportService } from '../../../services/documents/RetailSalesReportService';

export const RetailSalesReport: IAppEntity = {
  entityType: "document",
    title: "Retail Sales Reports",
    pluralTitle: "Retail Sales Reports",
    apiUrl: "RetailSalesReports",
    apiEnum: ReferenceTypes.DocumentRetailSalesReport,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(RetailSalesReportDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(RetailSalesReportList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupRetailSalesReport, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new RetailSalesReportService("RetailSalesReports"),
  getEmptyModel: () => {
        const model: CreateRetailSalesReportDto = {
            totalAmount: 0,
            totalAmountVat: 0,
          status: 0,
          
          documentDate: new Date(),
          createdDate: new Date(),
          products:[],
          payment:[],
        };
        return model;
      },
};

